export default __webpack_public_path__ + "static/media/conclusion-placeholder.a0fb6f48.svg";